<template>
<div>
  <div class="vx-row">
    <vx-card title="NUMBER SEQUENCE">
      <div slot="no-body" class="mt-4">
        <vs-table id="users-list"
                  :data="sequenceList"  @sort="handleSort"  :sst="true" stripe
                  class="table-dark-inverted table-auto vs-con-loading__container">
          <template slot="thead">
            <vs-th width="20%" sort-key="id">ID</vs-th>
            <vs-th width="20%" sort-key="name">NAME</vs-th>
            <vs-th width="20%" sort-key="name">SEQUENCE STATUS</vs-th>
            <vs-th width="20%" sort-key="name">ACTION</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr  :key="index" v-for="(tr, index) in data">
              <vs-td :data="data[index].id">
                {{ data[index].id}}
              </vs-td>
              <vs-td :data="data[index].name">
                {{ data[index].name }}
              </vs-td>
              <vs-td :data="data[index].is_editable" :class="data[index].is_editable ? 'text-danger' : 'text-primary'">
                {{ data[index].data_count === 0 ? 'BLANK' : data[index].is_editable ? 'SEQUENCE SELECTED' : ' LIVE SEQUENCE'}}
              </vs-td>
              <vs-td>
                <vx-tooltip v-if="data[index].is_editable" class="mr-2" text="Edit" position="left">
                  <vs-button @click.stop="editSequence(data[index])"
                             size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                </vx-tooltip>
                <vx-tooltip v-if="!data[index].is_editable" class="mr-2" text="View" position="left">
                  <vs-button @click.stop="editSequence(data[index])"
                             size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                </vx-tooltip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
  <sequence-update-pop-up ref="updateSequence"/>
</div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import SequenceUpdatePopUp from "@/components/popups/tenants/SequenceUpdatePopUp";
const TenantSettingRepository = RepositoryFactory.get('settings')
export default {
  name: "NumberSequence",
  data () {
    return {
      tenantId: '',
      sequenceList: {},
      meta: {},
      page : 1,
    }
  },
  mounted() {
    this.tenantId= this.$route.params.id
    this.fetchSequenceList()
  },
  components: {
    SequenceUpdatePopUp
  },
  methods : {
    async refreshData(){
      await this.fetchSequenceList()
    },
    async fetchSequenceList(){
        this.$vs.loading()
        const {data} = await TenantSettingRepository.getTenantSequenceList(this.tenantId,0)
        this.sequenceList = data.data
        this.$vs.loading.close()
      },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchSequenceList()
      }
    },
    editSequence(tr) {
      this.$refs.updateSequence.openPopUp(tr.id, tr.name)
    }
  }
}
</script>

<style scoped>

</style>
